/* eslint-disable no-unused-vars */
import React, { useState, useEffect ,forwardRef,
  useImperativeHandle, } from 'react';
import axios from 'axios';
import axiosInstance from '../../utils/axiosInstance';
import $ from 'jquery';

import { toast } from 'react-toastify';
import SwRadio from '../Common/FormComponent/SwRadio';
import SwButton from '../Common/SwButtons/SwButtons';

const CompanyLevelSettingModal = forwardRef((props, ref) => {
  const [serviceCustomization, setServiceCustomization] = useState({
    mr: false,
    vms: false,
  });

  // Get data from localStorage on mount
  useEffect(() => {
    const companyData = JSON.parse(localStorage.getItem('headData'));
 
    if (companyData?.companyWiseBooking) {
      setServiceCustomization(companyData.companyWiseBooking);
    }

  }, []);

  // Handle change of radio buttons
  const handleChange = (field, value) => {
    setServiceCustomization(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  // Submit updated data
  const handleUpdate = async () => {
    // Get organization data from localStorage
    const organizationData = JSON.parse(localStorage.getItem('headData'));

    // Validate organization data exists
    if (!organizationData?.organizationId) {
      toast.error('Organization data not found or missing organization ID');
      return;
    }

    try {
      // Make PUT request to update service customization
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL}core/organizations/${
          organizationData.organizationId
        }/service-customization`,
        serviceCustomization,
        {
          headers: {
            'req-organization-id': organizationData.organizationId,
            'Content-Type': 'application/json',
            // Authorization header will be automatically added by axiosInstance if configured
          },
        },
      );

      
      // Handle successful response
      if (response.status === 200) {
        toast.success(response.data.message, {});
           props.onSuccess()
        // Update local storage with new settings
        const updatedHeadData = {
          ...organizationData,
          companyWiseBooking: serviceCustomization,
        };
        localStorage.setItem('headData', JSON.stringify(updatedHeadData));

      } else {
        throw new Error(response.data?.message || 'Unknown server response');
      }
    } catch (error) {
      console.error('Update failed:', error);

      // Extract error message with fallbacks
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to update service settings';

      toast.error(errorMessage);
    }
  };

  const resetForm = () => {
    const original = JSON.parse(localStorage.getItem('headData'));
    if (original?.companyWiseBooking) {
      setServiceCustomization(original.companyWiseBooking);
    }
  };
    useImperativeHandle(ref, () => ({
    handleUpdate,
    resetForm,
  }));

  return (
    <>
      <div>
        <div className="formAddmemGrid">
          <label>Set company-wide defaults for new users.</label>
          <p>
            Set default feature access company-wise. Choose "Yes" to enable the
            service for all users & "No" to disable the service (you can
            selectively allow feature access for some users by editing member
            access).{' '}
          </p>
        </div>

        {/* === Meeting Room === */}
        <div className="SwFormGroup">
          <label className="SwFormLabel d-block">1. Meeting Room</label>

          <div>
            <SwRadio
              id="MeetingRoom_Yes"
              name="MeetingRoom1"
              label="Yes"
              checked={serviceCustomization.mr !== true}
              onChange={() => handleChange('mr', false)}
              inline
            />

            <SwRadio
              id="MeetingRoom_No"
              name="MeetingRoom1"
              label="No"
              checked={serviceCustomization.mr === true}
              onChange={() => handleChange('mr', true)}
              inline
            />
          </div>
        </div>

        {/* === VMS === */}
        <div className="SwFormGroup">
          <label className="SwFormLabel d-block">2. VMS</label>

          <div>
            <SwRadio
              id="VMS_Yes"
              name="VMS_1"
              label="Yes"
              checked={serviceCustomization.vms !== true}
              onChange={() => handleChange('vms', false)}
              inline
            />

            <SwRadio
              id="VMS_No"
              name="VMS_1"
              label="No"
              checked={serviceCustomization.vms === true}
              onChange={() => handleChange('vms', true)}
              inline
            />
          </div>
        </div>
      </div>
    </>
  );
});

export default CompanyLevelSettingModal;
